import { Menu, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useUIStore } from "@/store/ui";
import CreditChip from "./CreditChip";
import NotificationBell from "./NotificationBell";
import UserMenu from "./UserMenu";

export default function Topbar() {
  const toggle = useUIStore((s) => s.toggleSidebar);

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:px-6">
      <Button
        variant="ghost"
        size="icon"
        onClick={toggle}
        className="md:flex"
        aria-label="Toggle sidebar"
      >
        <Menu className="size-5" />
      </Button>

      <div className="relative hidden flex-1 max-w-md md:block">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search…"
          className="pl-8"
          aria-label="Global search"
        />
      </div>

      <div className="ml-auto flex items-center gap-2">
        <CreditChip />
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
